module.exports = __webpack_public_path__ + "media/images/dn-2-01e5214c.jpg";